module.exports = __webpack_public_path__ + "static/media/C8FDD777-E3B4-4934-B014-66FD69B75026.ea794834.jpeg";